import { create } from 'zustand';

export interface Notification {
  id: number;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  timestamp: Date;
  read: boolean;
}

interface NotificationStore {
  notifications: Notification[];
  addNotification: (notification: Omit<Notification, 'id' | 'timestamp' | 'read'>) => void;
  markAsRead: (id: number) => void;
  clearNotification: (id: number) => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [
    {
      id: 1,
      title: 'Project Milestone',
      message: 'Identity Federation Hub: Authentication module completed',
      type: 'success',
      timestamp: new Date('2023-08-15T10:00:00'),
      read: false
    },
    {
      id: 2,
      title: 'Resource Update',
      message: 'Sarah Chen is now available for new projects',
      type: 'info',
      timestamp: new Date('2023-08-15T09:30:00'),
      read: false
    }
  ],
  addNotification: (notification) =>
    set((state) => ({
      notifications: [
        {
          ...notification,
          id: state.notifications.length + 1,
          timestamp: new Date(),
          read: false
        },
        ...state.notifications
      ]
    })),
  markAsRead: (id) =>
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, read: true } : n
      )
    })),
  clearNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id)
    }))
}));